import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_Toast = _resolveComponent("Toast")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Nav = _resolveComponent("Nav")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppFooter = _resolveComponent("AppFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BlockUI, {
      blocked: _ctx.loadingCount > 0,
      "full-screen": true
    }, null, 8, ["blocked"]),
    _createVNode(_component_Toast),
    _createVNode(_component_ConfirmDialog),
    _createVNode(_component_Nav),
    _createVNode(_component_router_view),
    (_ctx.store.token)
      ? (_openBlock(), _createBlock(_component_AppFooter, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}